import { User } from 'lucide-react';

interface Step1Props {
  data: {
    name: string;
    email: string;
    phone: string;
    fax: string;
    streetAddress: string;
    submitter: string;
    submitterTitle: string;
  };
}

export default function Step1ApplicationInfo({ data }: Step1Props) {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-gray-900'>
            <div className='flex items-center'>
              <User className='w-6 h-6 text-gray-900 mr-2' />
              <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-gray-900'>
                Step 1: Application Information
              </h2>
            </div>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <div>
            <h3 className='mt-1 max-w-2xl text-sm font-medium text-gray-500'>Applicant / Business / Borrower Information</h3>
            <dl className='mt-4 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Name</dt>
                <dd className='mt-1 text-sm text-gray-900'>{data.name}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Address</dt>
                <dd className='mt-1 text-sm text-gray-900'>{data.streetAddress}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Phone</dt>
                <dd className='mt-1 text-sm text-gray-900'>{data.phone}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Fax</dt>
                <dd className='mt-1 text-sm text-gray-900'>{data.fax || 'None'}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Email</dt>
                <dd className='mt-1 text-sm text-gray-900'>{data.email}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Submitter</dt>
                <dd className='mt-1 text-sm text-gray-900'>{data.submitter}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Submitter Title</dt>
                <dd className='mt-1 text-sm text-gray-900'>{data.submitterTitle}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
